import {
  ChangePasswordForm
} from "./chunk-TFADRKHV.mjs";
import {
  useChangePassword
} from "./chunk-76GTUTYA.mjs";
import {
  CHANGE_PASSWORD_FORM_ID
} from "./chunk-Y6C2WA2G.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";
import {
  useLayoutContext
} from "./chunk-HFINPXUM.mjs";

// src/internal/components/change-password-panel/change-password-panel.tsx
import Stack from "@mui/material/Stack";
import { useAuthContext } from "@clara/auth";
import { useT } from "@clara/locale";
import { Button } from "@clara/ui";
import { jsx } from "react/jsx-runtime";
var ChangePassword = () => {
  const [{ loading, error }, onSubmit] = useChangePassword();
  const { sidePanel } = useLayoutContext();
  const { signOut } = useAuthContext();
  return /* @__PURE__ */ jsx(Stack, { spacing: 3, children: /* @__PURE__ */ jsx(
    ChangePasswordForm,
    {
      loading,
      error,
      onSubmit: (xs) => onSubmit(xs).then(() => {
        sidePanel.setPanelAt(2);
        signOut();
      })
    }
  ) });
};
var ChangePasswordPanelHeader = () => {
  const { t } = useT("common");
  return /* @__PURE__ */ jsx(
    SidePanelHeader,
    {
      variant: "alternate",
      headline: t("profile.action.changePassword")
    }
  );
};
var ChangePasswordPanelFooter = () => {
  var _a, _b;
  const { t } = useT("common");
  const { panelFormData } = useAuthContext();
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "submit",
      form: CHANGE_PASSWORD_FORM_ID,
      disabled: !((_a = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _a.isValid),
      isLoading: (_b = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _b.loading,
      children: t("profile.action.changePassword")
    }
  );
};
var ChangePasswordPanel = {
  children: [
    {
      element: /* @__PURE__ */ jsx(ChangePassword, {}),
      header: /* @__PURE__ */ jsx(ChangePasswordPanelHeader, {}),
      footer: /* @__PURE__ */ jsx(ChangePasswordPanelFooter, {})
    }
  ]
};

export {
  ChangePasswordPanelHeader,
  ChangePasswordPanelFooter,
  ChangePasswordPanel
};
